module.exports = __webpack_public_path__ + "img/fb_logo.e5bab75b.svg";